export default __webpack_public_path__ + "static/media/Group 437.133972fa.png";